"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
var AnnouncementTypeEnum;
(function (AnnouncementTypeEnum) {
    AnnouncementTypeEnum["MEMBER"] = "MEMBER";
    AnnouncementTypeEnum["CREATOR"] = "CREATOR";
    AnnouncementTypeEnum["BOTH"] = "BOTH";
})(AnnouncementTypeEnum = exports.AnnouncementTypeEnum || (exports.AnnouncementTypeEnum = {}));
class AnnouncementsProvider extends DataProvider_1.default {
    get fragments() {
        return {
            Announcement: () => `
        ... on Announcement {
          id
          text
          time
          type
          maxFileNumber
        }
      `,
        };
    }
    search({ data }) {
        return this.query("announcementSearch", { data }, this.getFragment("Announcement"));
    }
    create({ data }) {
        return this.mutate("announcementUpdate", { data }, this.getFragment("Announcement"));
    }
    update({ data }) {
        return this.mutate("announcementUpdate", { data }, this.getFragment("Announcement"));
    }
    delete(id) {
        return this.mutate("announcementDelete", { id });
    }
}
exports.AnnouncementsProvider = AnnouncementsProvider;
//# sourceMappingURL=AnnouncementsProvider.js.map